import { inject } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { catchError, concatMap, map, tap } from 'rxjs/operators';
import { of } from 'rxjs';
import { CommonService } from '../services/common/common.service';
import { DateTimeService } from '../shared/services/date-time.service';
import { loadList, loadListFailure, loadObjectSuccess } from '../lib/action';

export const loadListEffect = createEffect(
  () => {
    const actions$ = inject(Actions);
    const commonService = inject(CommonService);
    const dateTimeService = inject(DateTimeService);

    return actions$.pipe(
      ofType(loadList),
      concatMap(({ listType }) => {
        switch (listType) {
          case 'profile':
            return commonService.getProfileDetails().pipe(
              map(res => {
                localStorage.setItem('userDetails', JSON.stringify(res));
                return loadObjectSuccess({ listType, data: res });
              }),
              tap(res => {
                dateTimeService.loadFromProfile((res as any)?.data);
              }),
              catchError(error => {
                return of(loadListFailure({ listType, error }))
              })
            );

          default:
            return of(loadListFailure({ listType, error: 'Unknown list type' }));
        }
      })
    );
  },
  { functional: true }
);
